<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Orion_take-a-photo" clip-path="url(#clip0_1217_3779)">
      <path
        id="layer2"
        d="M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        id="layer1"
        d="M24.1 11H20.35L18.4 9H13.6L11.65 11H7.9C7.66131 11 7.43239 11.0948 7.2636 11.2636C7.09482 11.4324 7 11.6613 7 11.9V21.1C7 21.3387 7.09482 21.5676 7.2636 21.7364C7.43239 21.9052 7.66131 22 7.9 22H24.1C24.3387 22 24.5676 21.9052 24.7364 21.7364C24.9052 21.5676 25 21.3387 25 21.1V11.9C25 11.6613 24.9052 11.4324 24.7364 11.2636C24.5676 11.0948 24.3387 11 24.1 11Z"
        stroke="currentColor"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <circle id="Ellipse 13" cx="16" cy="16.5" r="2.5" stroke="currentColor" />
    </g>

    <defs>
      <clipPath id="clip0_1217_3779">
        <rect width="32" height="32" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
</template>
